const invoicePaymentStatusConstants = Object.freeze({
  DUE: 'DUE',
  OVERDUE: 'OVERDUE',
  PAID: 'PAID',
  PAID_OUTSIDE: 'PAID_OUTSIDE',
  PROCESSING: 'PROCESSING',
  UPCOMING: 'UPCOMING'
});

const invoiceStatusConstants = Object.freeze({
  MATCHED: 'MATCHED',
  PARSED: 'PARSED',
  PENDING: 'PENDING'
});

const invoiceTypeConstants = Object.freeze({
  INVOICE: 'INVOICE',
  NO_RECEIPT: 'NO_RECEIPT',
  RECEIPT: 'RECEIPT'
});

const invoiceMatchTypeConstants = Object.freeze({
  AUTOMATED: 'AUTOMATED',
  MANUAL: 'MANUAL',
});

const invoiceApprovalStatusConstants = Object.freeze({
  ASSIGNED: 'ASSIGNED',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  UNASSIGNED: 'UNASSIGNED',
});

const invoiceVatTypeConstants = Object.freeze({
  STANDARD: 'STANDARD',
  REDUCED: 'REDUCED',
  SUPER_REDUCED: 'SUPER_REDUCED',
  EXEMPT: 'EXEMPT'
});

export {
  invoicePaymentStatusConstants,
  invoiceStatusConstants,
  invoiceTypeConstants,
  invoiceMatchTypeConstants,
  invoiceApprovalStatusConstants,
  invoiceVatTypeConstants
};
